export default "__VITE_ASSET__C4W8yE5o__"